import TransactionActionTypes from './types/ActionTypes'
import {CCAuthorizedAxios} from './../../cc-imports'

const Actions = {
    fetchTransactions: (accessToken, userId, skip, limit, type) => {
        return {
            type: TransactionActionTypes.GET_TRANSACTIONS,
            payload: CCAuthorizedAxios(accessToken).get('/transaction/userId/' + userId + '/skip/' + skip + '/limit/' + limit + '/'),
            meta: {
                type: type,
                id:userId
            }
        }
    }
};

export default Actions



// WEBPACK FOOTER //
// ./src/app/data/actions/TransactionActions.js